import { QUALITY_FORMS } from '../../config/endoTaxonomy';

/**
 * Селектор формы чек-листа у графиков качества «Сотрудников». Формы — чек-лист-ноды
 * активного пакета; legacy-перечень остаётся, пока пакета нет.
 *
 * Имя у селектора обязательно: на одном экране их два (динамика и сравнение), и без имени
 * их не различить ни скринридеру, ни тесту.
 */
const QualityFormSelect = ({ value, onChange, forms, trackId }) => (
  <select
    data-ev={trackId}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    aria-label="Форма оценки"
    className="rounded-md border bg-background px-2 py-1 text-sm text-foreground"
  >
    <option value="all">Все формы</option>
    {(Array.isArray(forms) && forms.length > 0 ? forms : QUALITY_FORMS).map((form) => (
      <option key={form.code} value={form.code}>
        {form.label}
      </option>
    ))}
  </select>
);

export default QualityFormSelect;
